import { createSlice } from "@reduxjs/toolkit";
import { searchTransactionReport } from "./TransactionSearchReport.thunk";

const baseState = {
  status: "idle",
  error: null,
  retryCount: 0,
  responseData: null,
};

const initialState = {
  ...baseState,
};

export const transactionSearchReportSlice = createSlice({
  name: "transactionSearchReport",
  initialState,
  reducers: {
    ResetStore: () => ({ ...baseState }),
    setSearchProgress: (state, action) => {
      state.retryCount = action.payload?.retryCount ?? 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchTransactionReport.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.retryCount = 0;
      })
      .addCase(searchTransactionReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.responseData = action.payload.data;
        state.retryCount = action.payload.retryCount ?? 0;
        state.error = null;
      })
      .addCase(searchTransactionReport.rejected, (state, action) => {
        state.status = "failed";
        state.error =
          action.payload?.message || "Error generating transaction search";
        state.responseData = null;
        state.retryCount = action.payload?.retryCount ?? 0;
      });
  },
});

export const { ResetStore, setSearchProgress } =
  transactionSearchReportSlice.actions;

export default transactionSearchReportSlice.reducer;
